import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AddImageSvg } from '../../assets/svgs';
import { ImageFieldWrapper, ImageInput } from './image-field-base64.style';

const ImageFieldBase64Component = ({
    size = 200,
    rounded,
    accept = 'image/*',
    name,
    value,
    valueMust,
    onChange,
    disabled,
}) => {
    const [preview, setPreview] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = reader.result;
                if (!valueMust) {
                    setPreview(base64);
                }
                if (name && onChange) {
                    onChange({ name, value: base64 });
                }
            };
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => {
        if (!valueMust) {
            setPreview(value);
        }
    }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ImageFieldWrapper size={size} $rounded={rounded} $disabled={disabled} className={disabled ? 'disabled' : ''}>
            {
                !disabled && (
                    <ImageInput key={value || preview} type="file" accept={accept} onChange={handleFileChange} $disabled={disabled} />
                )
            }
            {
                value || preview ?
                    <img src={value || preview} alt="Preview" />
                    :
                    <AddImageSvg />
            }
        </ImageFieldWrapper>
    );
};

ImageFieldBase64Component.propTypes = {
    size: PropTypes.number,
    rounded: PropTypes.bool,
    accept: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    valueMust: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default ImageFieldBase64Component;
